var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5418 10.9403C10.3421 11.1546 10.1012 11.3266 9.83357 11.4458C9.56593 11.5651 9.27702 11.6292 8.98407 11.6344C8.69111 11.6395 8.40012 11.5856 8.12844 11.4759C7.85677 11.3662 7.60998 11.2028 7.4028 10.9957C7.19562 10.7885 7.03229 10.5417 6.92255 10.27C6.81282 9.99834 6.75893 9.70735 6.7641 9.4144C6.76927 9.12144 6.83339 8.83253 6.95264 8.5649C7.07189 8.29726 7.24382 8.05639 7.45818 7.85664M13.32 13.7185C12.0768 14.6661 10.563 15.1911 9 15.2166C3.90909 15.2166 1 9.39846 1 9.39846C1.90465 7.71257 3.15937 6.23963 4.68 5.07846L13.32 13.7185ZM7.47273 3.75482C7.97333 3.63765 8.48586 3.57907 9 3.58028C14.0909 3.58028 17 9.39846 17 9.39846C16.5585 10.2244 16.032 11.0019 15.4291 11.7185L7.47273 3.75482Z",
    stroke: "#0D85FF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.39844L17 17.3984",
    stroke: "#0D85FF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.d75e21fe6ab615b413ff7b284882871b.svg";
export { ForwardRef as ReactComponent };